import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import App from './App';
import { Provider } from 'react-redux';
import store from './store/index';
import reportWebVitals from './reportWebVitals';
import StaticMessage from './components/message';
import { App as Ant } from 'antd';
import StaticAlert from './components/alert';

const Loading = React.lazy(() => import('@/components/loading'));


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(<Provider store={store}>
  <Ant>
    <StaticMessage />
    <StaticAlert />
    <Suspense fallback={<Loading/>}>
      <App />
    </Suspense>
  </Ant>
</Provider>);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
